import { useEffect, useState } from "react";

const useBrowserSettings = () => {
  const [isSafari, setIsSafari] = useState<boolean | null>(null);
  const [isGapp, setIsGapp] = useState<boolean | null>(null);
  const [isGappVersionOne, setIsGappVersionOne] = useState<boolean | null>(
    null
  );

  const [isGappAndroid, setIsGappAndroid] = useState<boolean | null>(null);
  const [isGappIos, setIsGappIos] = useState<boolean | null>(null);
  const [isAndroid, setIsAndroid] = useState<boolean | null>(null);
  useEffect(() => {
    if (typeof navigator !== "undefined") {
      setIsSafari(/^((?!chrome|android).)*safari/i.test(navigator.userAgent));
      setIsGapp(navigator.userAgent.includes("gApp"));
      setIsGappVersionOne(new RegExp(/gApp\/.*\/1/).test(navigator.userAgent));

      setIsGappAndroid(
        new RegExp(/gApp\/android\/1/).test(navigator.userAgent)
      );
      setIsGappIos(new RegExp(/gApp\/ios\/1/).test(navigator.userAgent));
      setIsAndroid(new RegExp(/Android/).test(navigator.userAgent));
    }
  }, []);

  return {
    isSafari,
    isAndroid,
    isGapp,
    isGappVersionOne,
    isGappAndroid,
    isGappIos,
  };
};

export default useBrowserSettings;
